import styled from "styled-components";
import {colors} from "../../../maps/colors";

export const InvAlertBox = styled.div`
    padding: 15px;
    display: grid;
    grid-template-columns: 1fr 1fr;

    &.selected {
        border: 1px solid ${colors.GREEN};
        border-radius: 4px;
    }
`;

export const InvAlertInfoData = styled.div`

`;

export const LoaderStyled = styled.div`
    text-align: center;
    padding: 10px;
`;

export const InvAlertSensorWrapper = styled.div`

`;

export const ImagePreviewInfoData = styled.div`
    img {
        width: 150px;
    }
`;

export const DataTableInfoData = styled.div`
    width: max-content;

    .label {
        color: ${colors.LIGHT_GRAY};
        font-size: 11px;
        margin-right: 5px;
    }

    .value {
        width: max-content;
    }
`;

export const VideoPreviewWrapperStyled = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    padding: 20px;
    margin-bottom: 20px;
`;

export const VideoPreviewStyled = styled.div`

`;